<template>
	<div v-if="visible" :class="['no-results', ...variantClassList]">
		<template v-if="variant === 'full'">
			<div
				class="no-results__container"
				v-if="!hasSearchFilter"
				data-testid="no-results-message"
			>
				<img
					class="no-results__graphic"
					:src="searchSvg"
					alt="Illustration of man holding magnifying glass"
				/>

				<div class="no-results__search-container">
					<div class="no-results__primary-text-full">
						{{ capitalizeFirstWord(primaryTextFull) }}
						<span
							class="no-results__emphasized-text"
							ref="emphasizedTextFull"
						>
							{{ emphasizedTextFull }}
						</span>
					</div>
					<div class="no-results__secondary-text">
						{{ secondaryTextFull }}
					</div>
				</div>
			</div>
			<div
				class="no-results__container"
				v-else
				data-testid="no-results-filtered-message"
			>
				<img
					class="no-results__graphic-filter"
					:src="noResultsSvg"
					alt="Illustration of man holding a wrench"
				/>

				<div class="no-results__filter-container">
					<div class="no-results__primary-text-full">
						We applied your filters. However, no results were found.
					</div>
					<div class="no-results__secondary-text">
						Try adjusting the filters or search criteria to return
						more results.
					</div>
				</div>
			</div>
		</template>
		<template v-else>
			<div
				class="no-results__container"
				v-if="!hasSearchFilter"
				data-testid="no-results-message-condensed"
			>
				<i class="icon no-results__icon icon-no-results"></i>
				<div class="no-results__text-container-condensed">
					<span
						class="no-results__primary-text-condensed"
						ref="primaryTextCondensed"
					>
						{{ primaryTextCondensed }}
					</span>

					<div class="no-results__secondary-text">
						{{ secondaryTextCondensed }}
					</div>
				</div>
			</div>
			<div
				class="no-results__container"
				v-else
				data-testid="no-results-filtered-message-condensed"
			>
				<i class="icon no-results__icon icon-search"></i>
				<div class="no-results__text-container-condensed">
					<div class="no-results__primary-text-condensed">
						No results were found.
					</div>
					<div class="no-results__secondary-text">
						Try adjusting the filters or search criteria.
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import BaseComponentMixin from '@/mixins/base-component-mixin.js';
import componentVariantMixin from '@/mixins/component-variant-mixin';
import variantClasses from './variant-classes/no-results-variant-classes';
import SearchSvg from '@/assets/search.svg';
import NoResultsSvg from '@/assets/no-results.svg';

export default {
	name: 'NoResultsMessage',
	data() {
		return {
			searchSvg: SearchSvg,
			noResultsSvg: NoResultsSvg
		};
	},
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		hasSearchFilter: {
			type: Boolean,
			default: false
		},
		primaryTextCondensed: {
			type: String,
			default: 'No Results Found.'
		},
		primaryTextFull: {
			type: String,
			default: 'we searched high and low.'
		},
		emphasizedTextFull: {
			type: String,
			default: 'No Results Found.'
		},
		secondaryTextCondensed: {
			type: String,
			default: ''
		},
		secondaryTextFull: {
			type: String,
			default: ''
		}
	},
	mixins: [BaseComponentMixin, componentVariantMixin],
	created() {
		this.variantClasses = variantClasses;
	},
	methods: {
		capitalizeFirstWord(value) {
			if (!value) return '';
			value = value.toString();
			return (
				value.charAt(0).toUpperCase() +
				value.slice(1).replace(/\. *([a-z])/g, function(match, p1) {
					return '. ' + p1.toUpperCase();
				})
			);
		}
	}
};
</script>

<style lang="scss" scoped>
.no-results {
	margin: $gutter-lg 0;
	.no-results__container {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: $gutter-md;
		justify-content: center;
	}
	&__container-full {
		display: flex;
		align-items: flex-start;
		justify-content: center;
		margin-top: 100px;
	}

	&__text-container-condensed {
		max-width: 350px;
	}

	&__graphic {
		height: 185px;
	}

	&__graphic-filter {
		height: 263px;
	}

	&__search-container {
		margin-left: -60px;
		margin-top: 105px;
		max-width: 510px;
	}

	&__icon {
		font-size: 32px;
	}

	&__filter-container {
		margin-left: -68px;
		margin-top: 142px;
	}

	&__primary-text-condensed {
		@include heading(sm);
		text-transform: capitalize;
	}

	&__primary-text-full {
		@include heading(md);
	}

	&__emphasized-text {
		border-bottom: 1px solid var(--neutral-2);
		text-transform: capitalize;
	}

	&__secondary-text {
		font-size: $txt-font-size;
		word-wrap: break-word;
	}
}

.no-results--full-size {
	margin-top: 100px;
	.no-results__container {
		align-items: flex-start;
	}
}
</style>
